"use client"

import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";

export function ProjectCard({ title, description, image, technologies, link, color = "#8B5CF6", theme, index = 0 }) {
  return (
    <motion.div
      whileHover={{ y: -10 }}
      className="h-full flex flex-col group relative rounded-3xl overflow-hidden glass-panel border border-black/10 dark:border-white/10 hover:border-black/20 dark:hover:border-white/20 transition-all duration-300"
    >
      <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none z-0" style={{ background: `radial-gradient(circle at top right, ${color}20 0%, transparent 70%)` }} />
      
      {/* Image container */}
      <div className="relative h-64 overflow-hidden border-b border-black/5 dark:border-white/5">
        <img
          src={`/assets/images/projects/${image}` || "/placeholder.svg"}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-white/90 via-white/20 dark:from-black/90 dark:via-black/20 to-transparent" />
        
        {/* Badges overlapping image */}
        <div className="absolute bottom-4 left-4 right-4 flex flex-wrap gap-2">
          {technologies.map((tech, i) => (
            <div key={i} className="w-8 h-8 rounded-full glass bg-white/60 dark:bg-black/60 flex items-center justify-center p-1.5 shadow-lg border border-black/10 dark:border-white/10 hover:scale-110 transition-transform" title={tech.replace('.png', '')}>
              <img src={`/assets/images/${tech}`} alt={tech.replace('.png', '')} className="w-full h-full object-contain" />
            </div>
          ))}
        </div>
      </div>

      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-bold text-zinc-900 dark:text-white mb-2 heading-font group-hover:text-cyan-600 dark:group-hover:text-cyan-400 transition-colors">
          {title}
        </h3>
        <p className="text-zinc-600 dark:text-zinc-400 text-sm mb-6 flex-grow leading-relaxed">
          {description}
        </p>
        <div className="mt-auto">
          <a href={link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-zinc-900 dark:text-white uppercase tracking-wider heading-font hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors">
            View Project <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </motion.div>
  )
}
